import type { GameConfig } from '../contexts/GameContext';

/** Drop stale match identity when starting search or viewing results. */
export function clearOnlineSessionFields(cfg: GameConfig): GameConfig {
  return {
    size: cfg.size,
    ranked: cfg.ranked,
    local: cfg.local,
    mode: cfg.mode,
    ended: false,
  };
}
